import { render } from "./DocumentPositionTrainingTable.vue?vue&type=template&id=29e0ffd2&scoped=true&ts=true"
import script from "./DocumentPositionTrainingTable.vue?vue&type=script&lang=ts"
export * from "./DocumentPositionTrainingTable.vue?vue&type=script&lang=ts"

import "./DocumentPositionTrainingTable.vue?vue&type=style&index=0&id=29e0ffd2&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e0ffd2"]])

export default __exports__